import Favorite from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { colors } from '@startengine/design-system.theme.main';
import { Button } from '@startengine/design-system.ui.button';
import Image from 'next/legacy/image';

export const SubHeadingTypographyP2 = styled(Typography)(({ theme }) => ({
  ...theme.typography.p2,
  color: '#646464',
  margin: 0,
  fontWeight: 500,
  display: 'inline',
  alignItems: 'baseline',
  '.content-css a': {
    color: colors.SEDark,
    textDecoration: 'none',
  },
}));

export const FollowButtonStyled = styled(Button)(({ theme }) => ({
  ...theme.typography.p2Bold,
  padding: '0 34px',
  height: '44px',
  minHeight: '44px',
  borderRadius: '8px',
  position: 'static',
}));

export const CompanyCompsBox = styled(Grid)(({ theme }) => ({
  width: '100%',
  marginTop: 20,
  marginBottom: 40,
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    marginTop: 0,
    background: 'linear-gradient(64.45deg, #FFFFFF 16.05%, #efeff0 69.18%)',
    boxShadow:
      '0px 99px 59px rgba(0, 0, 0, 0.05), 0px 36.1366px 21.536px rgba(0, 0, 0, 0.0344991), 0px 17.5437px 10.4553px rgba(0, 0, 0, 0.0278145), 0px 8.60023px 5.12539px rgba(0, 0, 0, 0.0221855), 0px 3.40054px 2.02659px rgba(0, 0, 0, 0.0155009)',
    borderRadius: '16px',
    backdropFilter: 'blur(2px)',
    width: '369px',
    zIndex: 5,
  },
  [theme.breakpoints.up('md')]: {
    display: 'block',
  },

  [theme.breakpoints.up('lg')]: {
    marginTop: 0,
    marginBottom: 0,
  },
}));

export const CriteriaBadgeBox = styled(Grid)(() => ({ width: '100%', zIndex: 10 }));

export const CompsGrid = styled(Grid)(({ theme }) => ({
  ...theme.typography.p1,
  textTransform: 'uppercase',
  [theme.breakpoints.up('sm')]: {
    background: 'none',
    boxShadow: 'none',
    backdropFilter: 'none',
    borderRadius: 0,
    padding: '40px 0px 30px 40px',
  },
  color: '#999',
  letterSpacing: '2px',
  background: 'linear-gradient(64.45deg, #FFFFFF 16.05%, #efeff0 69.18%)',
  boxShadow:
    '0px 99px 59px rgba(0, 0, 0, 0.05), 0px 36.1366px 21.536px rgba(0, 0, 0, 0.0344991), 0px 17.5437px 10.4553px rgba(0, 0, 0, 0.0278145), 0px 8.60023px 5.12539px rgba(0, 0, 0, 0.0221855), 0px 3.40054px 2.02659px rgba(0, 0, 0, 0.0155009)',
  borderRadius: '16px',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
}));

export const BottomCompsGrid = styled(Grid)(({ theme }) => ({
  ...theme.typography.p1,
  textTransform: 'uppercase',
  padding: '20px 16px 20px',
  [theme.breakpoints.up('sm')]: {
    background: 'none',
    boxShadow: 'none',
    backdropFilter: 'none',
    borderRadius: 0,
    padding: '0 !important',
  },
  color: '#999',
  letterSpacing: '2px',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
}));

export const InnerCompsGrid = styled(Grid)(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    borderRadius: '16px 16px 0 0',
    height: '60px',
  },
}));

export const LoyaltyWrapper = styled('div')(({ theme }) => ({
  background: theme.palette.secondary.main,
  borderRadius: '16px 16px 0px 0px',
  position: 'absolute',
  width: '369px',
  height: '122px',
  zIndex: -1,
  top: '-60px',
  left: 0,
  [theme.breakpoints.up('sm')]: {},
}));

export const LoyaltyInner = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: '8px 16px',
  [theme.breakpoints.up('sm')]: {},
}));

export const TextWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '10px',
  [theme.breakpoints.up('sm')]: {},
}));

export const LoyaltyTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.popover,
}));

export const LoyaltySubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.dark,
}));

export const InvestButton = styled(Button)(({ theme }) => ({
  ...theme.typography.p2,
  borderRadius: '16px',
  width: '171px',
  fontWeight: '600',
  fontSize: '20px',
  display: 'flex',
  flexDirection: 'column',
  padding: '9px 16px !important',
  backgroundColor: '#185C65',
  [theme.breakpoints.up('sm')]: {
    width: '327px',
  },
}));

export const ImageLogo = styled(Image)(() => ({
  width: '48px',
  height: '48px',
  border: `1px solid ${colors.gray1}!important`,
  borderRadius: '36px',
  opacity: '0.8',
}));

export const InvestBox = styled(Box)(({ theme, hasrewards }) => ({
  fontSize: '11px',
  color: colors.gray1,
  padding: hasrewards ? '0 16px' : 0,
  [theme.breakpoints.up('sm')]: {
    fontSize: '12px',
    fontWeight: '500',
    color: colors.white,
  },
}));

export const HeartFilledStyled = styled(Favorite)(({ theme, color }) => ({
  backgroundColor: color,
  fill: theme.palette.secondary.main,
  borderRadius: '50%',
  cursor: 'pointer',
  zIndex: 3,
  padding: '10px',
  width: '22px',
  height: '22px',
  minWidth: '42px',
  minHeight: '42px',
  boxSizing: 'border-box',
}));

export const HeartStyled = styled(FavoriteBorderIcon)(({ color }) => ({
  backgroundColor: color,
  borderRadius: '50%',
  cursor: 'pointer',
  zIndex: 3,
  padding: '10px',
  width: '22px',
  height: '22px',
  minWidth: '42px',
  minHeight: '42px',
  boxSizing: 'border-box',
}));

export const ShowMoreTypography = styled(Typography)(() => ({
  color: colors.SEDark,
  cursor: 'pointer',
}));

export const CategoryStyled = styled(Typography)(() => ({
  lineHeight: '17px',
  fontSize: '10px',
  color: colors.gray2,
  backgroundColor: 'rgba(204,204,204,.2);',
  borderRadius: '3.93179px',
  fontWeight: '700',
  textTransform: 'uppercase',
  padding: '3px 5px',
  display: 'flex',
  alignItems: 'center',
  marginLeft: '15px',
}));

export const HeadingPillTypography = styled(Typography)(({ theme, color }) => ({
  ...theme.typography.p1Bold,
  color: color || theme.palette.common.dark,
  padding: '6px 10px',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  '.MuiSvgIcon-root': {
    marginBottom: '4px',
  },
  button: {
    marginTop: 0,
  },
}));

export const AccreditedInvestorsTypography = styled(Typography)(({ theme }) => ({
  ...theme.typography.p1Bold,
  color: theme.palette.primary.main,
  display: 'flex',
  padding: '6px 10px',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  '.MuiSvgIcon-root': {
    marginBottom: '4px',
  },
  button: {
    marginTop: 0,
  },
}));

export const HeadingTypography = styled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 400,
  letterSpacing: 2,
  textAlign: 'left',
}));

export const SubHeadingTypography = styled(Typography)(() => ({
  color: colors.gray1,
  margin: '10px 0',
  display: 'flex',
  fontSize: '14px',
  '.content-css a': {
    color: colors.SEDark,
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 700,
  },
}));

export const FollowButton = styled(Button)(({ theme }) => ({
  ...theme.typography.p2Bold,
  padding: '0 34px',
  height: '44px',
  minHeight: '44px',
  borderRadius: '8px',
}));

export const ShareButton = styled(Box)(({ theme }) => ({
  background: colors.gray7,
  padding: '0',
  width: '44px',
  height: '44px',
  minWidth: '44px',
  minHeight: '44px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    width: '44px !important',
    height: '44px',
    minWidth: '44px',
    minHeight: '44px',
    borderRadius: '50%',
  },
}));

export const PlayCircleIconStyled = styled(Image)(() => ({
  border: `2px solid ${colors.SEDark}`,
  cursor: 'pointer',
}));

export const WebsiteButton = styled(Button)(({ theme }) => ({
  ...theme.typography.p2Bold,
  padding: '0 16px',
  height: '44px',
  minHeight: '44px',
  borderRadius: '8px',
}));

export const HeadingGrid = styled(Grid)(({ theme }) => ({
  background: 'linear-gradient(180deg, #FFFFFF 35.38%, #F6FFFD 104.68%)',
  paddingTop: '23px',
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    width: '100%',
    background: 'none',
    paddingTop: 0,
    borderRadius: 0,
    position: 'none',
    top: 0,
    boxShadow: 'none',
    padding: 0,
    flexDirection: 'row',
    maxWidth: '100%',
  },
  [theme.breakpoints.up('lg')]: {
    marginTop: '60px',
  },
}));

export const InvestWrapper = styled('div')(({ theme }) => ({
  boxShadow:
    '-0.217625px -6.99662px 28px rgba(0, 0, 0, 0.03), -0.141053px -4.53484px 16.3981px rgba(0, 0, 0, 0.0209549), -0.0838259px -2.69499px 8.91852px rgba(0, 0, 0, 0.0158889), -0.043525px -1.39932px 4.55px rgba(0, 0, 0, 0.0130312), -0.0177324px -0.570095px 2.28148px rgba(0, 0, 0, 0.0106111), -0.00403009px -0.129567px 1.10185px rgba(0, 0, 0, 0.00685764)',
  background: colors.white,
  width: '100%',
  display: 'flex',
  padding: '20px 0',
  justifyContent: 'space-around',
  alignItems: 'center',
  position: 'fixed',
  bottom: 0,
  zIndex: 10,
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-100px',
    left: 0,
    right: 0,
    height: '100px',
    backgroundColor: 'inherit',
  },
  [theme.breakpoints.up('sm')]: {
    boxShadow:
      '0px 24.33px 17.5728px rgba(0, 0, 0, 0.0390953), 0px 10.11px 7.29885px rgba(0, 0, 0, 0.03), 0px 3.66px 2.63985px rgba(0, 0, 0, 0.0209047)',
    borderRadius: '16px',
    padding: '20px',
    paddingBottom: '20px',
    width: 'auto',
    position: 'static',
    '&::after': {
      display: 'none',
    },
  },
  [theme.breakpoints.down('sm')]: {
    opacity: (props) => (props['data-scrolling'] === 'true' ? 1 : 0),
    visibility: (props) => (props['data-scrolling'] === 'true' ? 'visible' : 'hidden'),
    transition: 'opacity 0.3s ease, visibility 0.3s ease',
  },
}));

export const ClosedButton = styled(Button)(({ theme }) => ({
  ...theme.typography.p2,
  padding: '0 34px',
  height: '48px',
  borderRadius: '16px',
  fontWeight: 700,
  backgroundColor: colors.gray4,
  color: colors.white,
  width: '100%',
}));

export const TestingButton = styled(Button)(({ theme }) => ({
  ...theme.typography.p2,
  padding: '0 34px',
  height: '48px',
  width: '100%',
  borderRadius: '16px',
  fontWeight: 700,
  backgroundColor: '#E06004',
  color: colors.white,
  ':hover': {
    backgroundColor: '#E06004',
  },
}));

export const InvestButtonLarge = styled(Button)(({ theme }) => ({
  ...theme.typography.p1,
  width: '100% !important',
  borderRadius: '16px',
  fontWeight: 600,
  padding: '13px 0',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '327px',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    width: '50% !important',
  },
  [theme.breakpoints.up('md')]: {
    display: 'initial',
  },
}));

export const IraOnlySubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.p1,
  width: '100% !important',
  marginTop: '3px',
  textAlign: 'center',
  fontSize: '14px',
  fontWeight: 600,
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '327px',
    width: '50% !important',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background:
      'linear-gradient(45deg, transparent 45%, rgba(255,255,255,0.8) 50%, transparent 55%)',
    transform: 'translateX(-100%)',
    animation: 'shine 4s forwards',
  },
  '@keyframes shine': {
    to: {
      transform: 'translateX(100%)',
    },
  },
}));

export const IraOnlySubtext = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 600,
  marginTop: '3px',
  textAlign: 'center',
  position: 'relative',
  overflow: 'hidden',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    left: '-50%',
    width: '200%',
    height: '200%',
    background:
      'linear-gradient(45deg, transparent 45%, rgba(255,255,255,0.8) 50%, transparent 55%)',
    transform: 'translateX(-100%)',
    animation: 'shine 4s forwards',
  },
  '@keyframes shine': {
    to: {
      transform: 'translateX(100%)',
    },
  },
}));

export const IraDisclaimer = styled(Typography)(() => ({
  fontSize: '8px',
  fontWeight: 400,
  marginTop: '4px',
  textAlign: 'center',
  color: colors.gray1,
  lineHeight: '1.2',
  a: {
    color: colors.SEDark,
    textDecoration: 'underline',
  },
}));

export const TestingButtonLarge = styled(Button)(({ theme }) => ({
  ...theme.typography.p1,
  width: '100% !important',
  borderRadius: '16px',
  fontWeight: 600,
  padding: '13px 0',
  color: colors.white,
  backgroundColor: '#E06004',
  ':hover': {
    backgroundColor: '#E06004',
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: '327px',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    width: '50% !important',
  },
  [theme.breakpoints.up('md')]: {
    display: 'initial',
  },
}));
export const ClosedButtonLarge = styled(Button)(({ theme }) => ({
  ...theme.typography.p1,
  width: '100% !important',
  borderRadius: '16px',
  fontWeight: 600,
  color: colors.white,
  backgroundColor: colors.gray4,
  padding: '13px 0',
  ':hover': {
    backgroundColor: colors.gray4,
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: '327px',
  },
}));

export const CompsTypography = styled(Grid)(({ theme }) => ({
  ...theme.typography.h7,
  color: colors.SEDark,
}));

export const LegalGrid = styled(Grid)(({ theme }) => ({
  ...theme.typography.legal,
  padding: '16px 0px',
  color: colors.gray1,
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  [theme.breakpoints.up('md')]: {
    marginLeft: 'inherit',
    padding: '16px 0',
    textAlign: 'left',
  },
}));
export const SocialGrid = styled(Grid)(() => ({
  right: '20px',
  top: '30px',
  zIndex: 10,
  flexFlow: 'nowrap',
}));

export const AmountRaisedContainer = styled('div')(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: '40px',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
}));

export const TypographyTagLine = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.only('sm')]: {
    textAlign: 'center',
  },
}));

export const BackdropComponent = styled(Backdrop, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: (props, styles) => styles.backdrop,
})({
  zIndex: -1,
  background: 'rgba(0, 0, 0, 0.6)',
  backdropFilter: 'blur(30px)',
});

export const ShowMoreStyling = styled(Typography)(({ theme }) => ({
  '.content-css a': {
    color: theme.palette.common.dark,
    textDecoration: 'none',
  },
}));

export const PhoneGrid = styled(Grid)(() => ({
  borderRadius: '16px',
  border: '1px solid #F0EAE0',
  background: 'linear-gradient(267deg, #EFE9E0 14.5%, #F9F5F0 70.58%)',
  boxShadow:
    '0px 58px 16px 0px rgba(0, 0, 0, 0.00), 0px 37px 15px 0px rgba(0, 0, 0, 0.01), 0px 21px 12px 0px rgba(0, 0, 0, 0.02), 0px 9px 9px 0px rgba(0, 0, 0, 0.04), 0px 2px 5px 0px rgba(0, 0, 0, 0.05)',
  backdropFilter: 'blur(2px)',
  padding: '6px 8px',
  position: 'relative',
  zIndex: 5,
}));
